const getKeywordsString = (keywordsList) => {
  if (!keywordsList.length) {
    return '';
  }

  return keywordsList.map(({ label }) => label).join(', ');
};

export default getKeywordsString;
